var map = {
	"./canada.png": "34bb",
	"./chile.png": "a4a5",
	"./china.png": "85ac",
	"./colombia.png": "668f",
	"./de.png": "72fea",
	"./en.png": "9996",
	"./france.png": "829e",
	"./japan.png": "2eb0",
	"./peru.png": "81f6",
	"./singapore.png": "0921",
	"./spain.png": "a594",
	"./tr.png": "12dd",
	"./united-states.png": "939c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "199d";